const rejectEmail = {
  shiptoNo: 'ShiptoNo',
  shiptoName: 'ShiptoName',
  primaryEmail: 'PrimaryEmail',
  primaryEmailValid: 'PrimaryEmailValid',
  backupEmail: 'BackupEmail',
  backupEmailValid: 'BackupEmailValid',
  msg: {}
};
export default rejectEmail;



// WEBPACK FOOTER //
// ./src/page/md/rejectEmail/lang/rejectEmail.en.js